import { Component, OnInit } from '@angular/core';
import {StsCmsService} from '../../../services/sts-cms-service.service';
import StsFooterModel from '../../../models/sts-footer.model';
import StsLink from '../../../models/sts-link.model';
import { environment } from 'environments/environment.prod';

declare let ua_track_event: Function;
declare let ua_record_page_view: Function;

@Component({
  selector: 'app-sts-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public showDialog: boolean;
  public dialogueItem: StsLink;
  public currentYear: number = (new Date()).getFullYear();

  public footerModel: StsFooterModel;

  public version: any;

  constructor(private cmsService: StsCmsService) {
    this.version = environment.version;
    this.footerModel = new StsFooterModel();
  }

  ngOnInit() {
    this.cmsService.getFooter().subscribe( a => {
      this.footerModel = a;
    });
  }

  public getCurrentLink() {
    return this.dialogueItem ? this.dialogueItem.href : '';
  }

  private setFocusToIframe() {
    let frame = (document.getElementById('iframeAbout') as HTMLIFrameElement);
    frame.contentWindow.focus();
    const inputArray = ['a', 'input', 'button', 'router-outlet']
    inputArray.forEach(elementA => {
      const nodeList= document.querySelectorAll(elementA);
      nodeList.forEach(element => {
        element.setAttribute('tabindex', '-1');
      });
    });
    let modalClose = document.getElementById('modalClose');
    modalClose.removeAttribute('tabindex');    
    let modalCloseIcon = document.getElementById('modalCloseIcon');
    modalCloseIcon.removeAttribute('tabindex');
  }

  public click(item: StsLink): boolean {
    if(typeof ua_record_page_view != "undefined")
      ua_record_page_view(item.title);
    if (item.type !== 'iframe') {
      window.open(item.href, item.target);
    } else {
      this.dialogueItem = item;
      this.showDialog = item != null;
      setTimeout(this.setFocusToIframe, 100);
    }
    return false;
  }

  public socialLinkClick(item: StsLink): boolean {
    if(typeof ua_track_event != "undefined")
      ua_track_event('Login Page Actions', 'External Link', item.href);
    return true;
  }
}